import { Pipe, PipeTransform } from '@angular/core';
import { BoxLink } from '../models/monitored-train';
import {ProjectConfiguration} from '../../project/models/project-configuration';

@Pipe({
  name: 'processBoxLinks'
})
export class ProcessBoxLinksPipe implements PipeTransform {

  transform(links: BoxLink[], projectConfiguration: ProjectConfiguration): unknown {
    
    const maxLinksPerRow = (projectConfiguration?.monitoringFleet?.maxLinksPerRow || 12) as number;

    if (!projectConfiguration?.monitoringFleet?.displayVlinks) {
      links = links.filter(link => !link.name.includes('vlink'))
    }

    return links.reduce((acc: BoxLink[][], link: BoxLink, idx: number) => {
      let groupId  = parseInt((idx/maxLinksPerRow).toString()) ;
      if (links.length > maxLinksPerRow) {
        const boxId = link.name.includes("-") && parseInt(link.name.split('-')[0].replace("b", "")) || 1;
        groupId = boxId -1;
      }
      if(!acc[groupId.toString()]) {
        acc[groupId.toString()] = []
      }
      acc[groupId].push(link);
      return acc 
  }, []);
  }

}
